import { useContext, useEffect, useState } from "react";
import { Separator } from "@moreirapontocom/npmhelpers";
import { isMobile, requestPushPermission } from "../../services/helpers";
import { DataContext } from "../../context/Data.context";

const Bluetooth = () => {
  // const _window: any = window.navigator;
  const _window: any = typeof window !== "undefined" ? window.navigator : {};
  // let server: any;
  const [, setServer] = useState(null as any);

  // let service: any;
  // var write_characteristic;
  // var read_characteristic;

  useEffect(() => {
    _checkNavigatorBluetoothAvailability();
    _checkIsMobile();
  }, []);

  const [isMobileDevice, setIsMobileDevice] = useState(false);

  const _checkIsMobile = () => {
    const is: boolean = isMobile();
    setIsMobileDevice(is);
    // console.log("Is mobile: ", is);
  };

  // const _askBtPermission = async () => {
  //   const btPermission: any = await navigator.permissions.query({ name: "bluetooth" as PermissionName });
  //   if (btPermission.state !== "denied") {
  //     console.log("Bluetooth permission granted");
  //     return;
  //   }

  //   console.log("Bluetooth permission denied");
  // };

  const [error, setError] = useState(null as any);

  const [bluetoothAvailable, setBluetoothAvailable] = useState(false);
  const _checkNavigatorBluetoothAvailability = async () => {
    try {
      _window.bluetooth.getAvailability().then((available: any) => {
        if (available) {
          setBluetoothAvailable(true);
          return;
        }
        setBluetoothAvailable(false);
      });
    } catch (error: any) {
      console.log("Error: ", error);
      setBluetoothAvailable(false);
    }
  };

  const [, setDevicesServices] = useState([] as any[]);
  const [, setDevicesCharacteristics] = useState([] as any[]);

  const [deviceBasicInfo, setDeviceBasicInfo] = useState({ id: "", name: "" });
  const [deviceName, setDeviceName] = useState("Metrix Reader");
  // const [primaryServices, setPrimaryServices] = useState([] as any[]);
  const [bluetoothDevice, setBluetoothDevice] = useState(null as any);
  const [isConnected, setIsConnected] = useState(false);


  const [primaryService, setPrimaryService] = useState(null as any);

  // const eventListener = (characteristics: any[]) => {
  //   characteristics.forEach((char: any) => {
  //     char.oncharacteristicvaluechanged = (event: any) => {
  //       console.group(`oncharacteristicvaluechanged: `, char.uuid);
  //       console.log(`Value changed:`, event.target.value);
  //       const value = event.target.value;
  //       const decoder = new TextDecoder("utf-8");
  //       const decodedValue = decoder.decode(value);
  //       console.log(`Received: ${decodedValue}`);
  //       console.groupEnd();
  //     };
  //   });
  // };

  const { data, setData } = useContext(DataContext);
  const _connectDevice = async () => {
    setError(null);
    setDevicesServices([]);
    setDevicesCharacteristics([]);

    // let gatt: any;
    // let services: any;

    const options: any = {
      filters: [
        {
          namePrefix: deviceName,
          acceptAllDevices: true,
        },
        {
          services: [
            "0000ABF0-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF1-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF2-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF3-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF4-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF7-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "0000ABF8-0000-1000-8000-00805f9b34fb".toLowerCase(),
            "00000000-0000-0000-0000-00000000abf5".toLowerCase(),
            "00000000-0000-0000-0000-00000000abf6".toLowerCase(),
          ],
        },
      ],
    };

    try {
      const device: any = await _window.bluetooth.requestDevice(options);

      if (!device) {
        console.log("Device not found");
        return;
      }

      setIsConnected(true);
      setBluetoothDevice(device);

      setDeviceBasicInfo({ name: device.name, id: device.id });


      const bluetoothServer: any = await device.gatt.connect();
      console.log("bluetoothServer", bluetoothServer);
      setServer(bluetoothServer);


      const primaryServices: any = await bluetoothServer.getPrimaryServices();
      if (!primaryServices) {
        console.log("primaryServices not found");
        return;
      }
      // console.log("primaryServices >>> ", primaryServices[0]);

      const primaryService: any = primaryServices[0];

      setPrimaryService(primaryService);

      // const service: any = await bluetoothServer.getPrimaryService("0000abf0-0000-1000-8000-00805f9b34fb");
      const service: any = await bluetoothServer.getPrimaryService(primaryService.uuid);
      // console.log("bluetooth service is: ", service);
      if (!service) {
        console.log("Whoops. Failed to access to Bluetooth. Try again.");
      }


      const chars: any = await primaryService.getCharacteristics();
      if (!chars) {
        console.log("chars not found");
        return;
      }

      chars.forEach((char: any) => {
        if (char.properties.notify || char.properties.indicate) {
          char.startNotifications();
          char.oncharacteristicvaluechanged = (event: any) => {
            console.group("oncharacteristicvaluechanged: ", char.uuid);
            console.log("Value changed: ", event.target.value);
            const value = event.target.value;
            const decoder = new TextDecoder("utf-8");
            const decodedValue = decoder.decode(value);
            console.log(`Received: ${decodedValue}`);

            setData({
              ...data,
              responseDevice: decodedValue,
            });

            console.groupEnd();
          };
        }

      });

      bluetoothServer.ongattserverdisconnnected = _disconnectDevice();
    } catch (error: any) {
      console.log(error);
      setError("Error: " + error.message);
    }
  };

  /**
   * The current device is not working properly, so user need to click twice to send messages.
   * This recursion hack is to bypass this problem.
   * When this is fixed by our engineering team, remove it.
   */

  const [message, setMessage] = useState("");
  const _sendMessage = async (count = 0) => {
    setData({
      ...data,
      responseDevice: "-",
    });

    if (count >= 3) {
      return;
    }

    if (primaryService && message) {
      const write: any = await primaryService.getCharacteristic("0000abf1-0000-1000-8000-00805f9b34fb");
      const messageToDevice: any = new TextEncoder().encode(message);
      return await write.writeValue(messageToDevice);
    }

    _sendMessage(count + 1);
  };

  const _disconnectDevice = async () => {
    setError(null);

    try {
      if (!bluetoothDevice) {
        return;
      }

      if (bluetoothDevice.gatt.connected) {
        bluetoothDevice.gatt.disconnect();
      } else {
        console.log("Already disconnected");
      }

      console.clear();

      setIsConnected(false);
      window.location.reload();
    } catch (error: any) {
      console.log("Erro ao desconectar", error);
    }
  };
  
  const _markAllTestsAsFinished = () => {
    const storageKey = "results";
    const resultsStorage: any = localStorage.getItem(storageKey);
    if (!resultsStorage) {
      return;
    }

    const results: any = JSON.parse(resultsStorage);
    const newResults: any = results.map((result: any) => {
      return {
        ...result,
        isRunning: false,
        result: "negative",
      };
    });
    localStorage.setItem(storageKey, JSON.stringify(newResults));
  };

  return <>
    <div className="container">
      <div>
        <h1>Bluetooth Web API - (DEVELOPER TESTS)</h1>

        <hr />

        <button type="button" className="me-2" onClick={() => requestPushPermission()}>Request Push Permission</button>
        <button type="button" onClick={() => {
          console.log("Sending push notification");
          new Notification("Sample Notification");
        }}>Send Push Notification</button>

        <hr />

        <button type="button" onClick={() => _markAllTestsAsFinished()}>
          Set all RUNNING tests as FINISHED
        </button>

        <hr />

        <button type="button" onClick={() => {
          localStorage.setItem("readers", JSON.stringify(
            [
              {
                "id":"6HQXSJmGzMKbt4VM+2DFnw==",
                "hashId":"4eea36a8d728cb734928b1124554b5563c0b94c95b64cf7358a38251df72bff7",
                "name":"Metrix Reader 24-100",
                "serialNumber":"1234",
                "firmwareVersion":"1.0.0",
              },
              {
                "id":"d/JZZlLVN4HNXHBuSwmbFQ==",
                "hashId":"5ee5ca6c79743dcd554bc96ddb314b4492d1509beabc6e6b012500d3108c58ca",
                "name":"Metrix Reader 30-100",
                "serialNumber":"1234",
                "firmwareVersion":"1.0.0",
              },
            ]
          ));
        }}>
          Create demo READERS data
        </button>

        <hr />




        {isMobileDevice && <>
          <div className="alert alert-danger">
            <strong>
              <h3>This device is not supported</h3>
            </strong>
          </div>
        </>}

        {!isMobileDevice && <>
          {bluetoothAvailable && <>
            <small className="text-success">
              <i className="fas fa-check-circle text-success me-2"></i> Web Bluetooth API is available.
            </small>
          </>}

          {!bluetoothAvailable && <>
            <small className="text-danger">
              <i className="fas fa-times-circle text-danger me-2"></i> Web Bluetooth API is not available, try turn on your bluetooth device or use another browser
            </small>
          </>}
        </>}
      </div>

      {!isMobileDevice && bluetoothAvailable && <>
        <Separator size={20} />

        <div className="card">
          <div className="card-body">

            <div className="row">
              <div className="col">
                <input
                  type="text"
                  value={deviceName}
                  disabled={isConnected}
                  onChange={(e: any) => setDeviceName(e.target.value)}
                  className="form-control"
                  placeholder="Enter device name" />
              </div>
              <div className="col">

                {!isConnected && <>
                  <button
                    onClick={() => _connectDevice()}
                    disabled={deviceName === ""}
                    className="btn btn-primary me-2">
                      <i className="fas fa-check me-2"></i> Connect
                  </button>
                </>}

                {isConnected && <>
                  <button
                    id="disconnect"
                    onClick={() => _disconnectDevice()}
                    className="btn btn-warning">
                      <i className="fas fa-times me-2"></i> Disconnect
                  </button>
                </>}
              </div>
            </div>

          </div>
        </div>

        {error && <div className="alert alert-danger mt-3 mb-3" role="alert">{JSON.stringify(error, null, 2)}</div>}

        <br />

        {isConnected && <>
          <br />
          <strong>Name:</strong> {deviceBasicInfo.name}<br />
          <strong>ID:</strong> {deviceBasicInfo.id}

          <Separator size={20} />

          <hr />

          <Separator size={20} />

          <div className="row">
            <div className="col-7">
              <div className="form-group">
                <input
                  type="text"
                  id="message"
                  value={message}
                  onChange={(e: any) => setMessage(e.target.value)}
                  disabled={!isConnected}
                  maxLength={6}
                  className="form-control"
                  placeholder="Enter message command" />
              </div>
            </div>
            <div className="col">
              <div className="d-grid">
                <button
                  type="button"
                  disabled={!isConnected || message === ""}
                  className="btn btn-primary"
                  onClick={() => _sendMessage(0)}>Send message</button>
              </div>
            </div>
          </div>

          <Separator size={10} />

          <small className="text-muted">
            Shortcuts: click on the buttons below to send predefined messages
          </small>

          <Separator size={10} />

          <div className="badge bg-primary me-2 cursor-pointer" onClick={() => setMessage("CMD06*")}>CMD06*</div>
          <div className="badge bg-primary me-2 cursor-pointer" onClick={() => setMessage("CMD08*")}>CMD08*</div>
          <div className="badge bg-primary me-2 cursor-pointer" onClick={() => setMessage("CMD09*")}>CMD09*</div>
          <div className="badge bg-primary me-2 cursor-pointer" onClick={() => setMessage("CMD10*")}>CMD10*</div>

          <Separator size={20} />

          ACK Response: <strong>{data.responseDevice}</strong>
        </>}

        {/*
        <label>Get MCU version:</label>
        <button id="get-reader-firmware">Get</button>
        <div id="get-reader-firmware-result"></div>

        <label>[MCU] Send end seq:</label>
        <button id="send-mcu-end-seq">Send</button>
        <div id="send-mcu-end-seq-result"></div>

        <label>[BLE] Send start seq:</label>
        <button id="send-ble-start-seq">Send</button>
        <div id="send-ble-start-seq-result"></div>

        <label>[BLE] Send end seq:</label>
        <button id="send-ble-end-seq">Send</button>
        <div id="send-ble-end-seq-result"></div>

        <label>[MCU] FOTA:</label>
        <button id="update-mcu">Update</button>
        <div id="update-mcu-result"></div>
        */}

      </>}
    </div>
  </>
};

export default Bluetooth;